import { UNIFIED_INTEGRATION_IDS } from 'integrations/unified/constants';

export const AZURE_INTEGRATION_ID = 'azure-v3';
export const AWS_INTEGRATION_ID = 'aws-v3';
export const EXCEL_INTEGRATION_ID = 'excel-v3';
export const SERVICENOW_INTEGRATION_ID = 'servicenow-v3';
export const SIGNAVIO_EXPORTER_INTEGRATION_ID = 'signavio-exporter';
export const IT_PEDIA_INTEGRATION_ID = 'it-pedia';
export const CELONIS_EXPORTER_INTEGRATION_ID = 'celonis-exporter';
export const FRAMEWORKS_AND_RESOURCES = 'frameworks-resources';
export const VISUAL_IMPORTER_INTEGRATION_ID = 'visual-importer';
export const IMPORT_BUILDER_INTEGRATION_ID = 'import-builder';
export const JSON_INTEGRATION_ID = 'json-importer';
export const SERVICENOW_GUIDED_EXPORTER_INTEGRATION_ID =
  'servicenow-guided-exporter';
export const PUBLIC_API = 'public-api';

export const EXPORT_INTEGRATION_IDS = [
  SIGNAVIO_EXPORTER_INTEGRATION_ID,
  CELONIS_EXPORTER_INTEGRATION_ID,
] as const;

export const NON_TABULAR_INTEGRATION_IDS = [
  FRAMEWORKS_AND_RESOURCES,
  VISUAL_IMPORTER_INTEGRATION_ID,
  PUBLIC_API,
] as const;

// This list doesn't include 'frameworks-resources' because that
// is an exception and it doesn't have same import ecosystem as other integrations.
export const INTEGRATION_IDS = [
  AWS_INTEGRATION_ID,
  AZURE_INTEGRATION_ID,
  EXCEL_INTEGRATION_ID,
  JSON_INTEGRATION_ID,
  SERVICENOW_INTEGRATION_ID,
  IT_PEDIA_INTEGRATION_ID,
  SERVICENOW_GUIDED_EXPORTER_INTEGRATION_ID,
  ...EXPORT_INTEGRATION_IDS,
  ...UNIFIED_INTEGRATION_IDS,
] as const;
